<div class="home-page main-container">
    <app-annonymous-home-view *ngIf="!isAuthenticated"></app-annonymous-home-view>
    
    <app-authenticated-home-view *ngIf="isAuthenticated"></app-authenticated-home-view>
</div>
   

